export default __webpack_public_path__ + "static/media/onboarding1.5d19fb3a.png";